import React from "react";
import "./style.scss";

interface Props {
  item: {
    title: string;
    description: string;
  };
}

export default function TestimonialInfoCard({ item }: Props) {
  return (
    <div className="testimonial-info-card d-flex __column gap-3 pa-6 fw-semibold box-shadow">
      <div className="testimonial-info-card__title">{item.title}</div>
      <div className="testimonial-info-card__devider"></div>
      <div className="testimonial-info-card__description body-big">{item.description}</div>
    </div>
  );
}
